<div class="d-flex align-items-center">
    <span class="fs-5 fw-bold">Owners:</span>
    @if (loadingOwners()) {
        <mat-spinner diameter="20" class="ml-2"></mat-spinner>
    }
</div>

@if (owners$ | async; as owners) {
    <ul>
        @for (owner of owners; track owner.id) {
            <li>
                <div class="d-flex align-items-center">
                    <span>{{ owner.displayName }}</span>
                    <button
                        mat-icon-button
                        (click)="removeOwnerClicked(owner.id)"
                        class="ml-1"
                        [disabled]="ownerIdBeingRemoved() !== ''"
                    >
                        @if (ownerIdBeingRemoved() === owner.id) {
                            <mat-spinner diameter="20" color="red"></mat-spinner>
                        } @else {
                            <mat-icon [class]="removeOwnerButtonClasses()">person_remove</mat-icon>
                        }
                    </button>
                </div>
            </li>
        }
    </ul>
}

<form class="d-flex align-items-center gap-2" [formGroup]="addOwnerForm">
    <app-user-graph-autocomplete controlName="owner" class="flex-grow-1" />
    <button
        mat-flat-button
        type="submit"
        class="ml-2"
        [disabled]="!addOwnerForm.valid || ownerIsBeingAdded()"
        (click)="addOwnerClicked()"
    >
        @if (ownerIsBeingAdded()) {
            <mat-spinner diameter="20"></mat-spinner>
        } @else {
            Add
        }
    </button>
</form>
